import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  bannersWrapper: {
    paddingTop: '32px',
    '&:empty': {
      display: 'none'
    }
  }
});
export default useStyles;